import { defineStore } from 'pinia'
import { ref, shallowRef } from 'vue'
import api from '@/plugins/api.js'

export const useAuthStore = defineStore('auth', () => {
  const _token = shallowRef(localStorage.getItem('token') ?? null)
  const _isLoggedIn = shallowRef(true)
  const _company = shallowRef({})
  const _isLoggingOut = shallowRef(false)
  const _user = ref(null)

  function setUserWithToken(user, token = null) {
    _user.value = user
    if (token) {
      addUserToken(token)
    }
  }

  function addUserToken(token) {
    _token.value = token
    localStorage.setItem('token', _token.value)
    api.addToken(_token.value)
  }

  async function loginWithXml(signed_xml) {
    const response = await api.auth.login_using_xml({ signed_xml })
    const { access_token, userData } = response.data
    setUserWithToken(userData, access_token)
    return response
  }


  // Вход через eGov Mobile: опрос сессии вернул токен.
  function loginWithToken(access_token, userData) {
    setUserWithToken(userData, access_token)
  }

  async function getCurrentUser() {
    const response = await api.auth.get_current_user()
    const userData = response.data.data
    setUserWithToken(userData, null)
  }

  function logout() {
    _isLoggingOut.value = true
    localStorage.removeItem('token')
    window.location = '/'
    _user.value = null
    _isLoggingOut.value = false
  }

  return {
    _token,
    _isLoggedIn,
    _company,
    _user,
    getCurrentUser,
    _isLoggingOut,
    logout,
    loginWithXml,
    loginWithToken,
  }
})
